<template>
  <div>
    <add-guest
      :is-add-guest-popup-opened="isAddGuestPopupOpened"
      :limit-guests="

        $freeParticulier() &&
          guests.filter((g) => g.is_active == true).length > 0
      "
      @close="isAddGuestPopupOpened = false"
    />

    <edit-guest-specific-rights
      :data-to-show="isSpecificRightsPopupOpened"
      @showChange="
        (val) => {
          changeSpecificRightsPopupState(val);
        }
      "
    />

    <delete-guest
      :data-to-show="isDeactivateGuestPopupOpened"
      @showChange="
        (val) => {
          changeDeactivateGuestPopupState(val);
        }
      "
    />

    <div
      class="flex content-center items-center justify-between my-15 2xl:my-20 mx-5 lg:mx-15 2xl:mx-20"
    >
      <!-- BEGIN Button to add a "guest" -->
      <add-button
        id="add-guest"
        :libelle="'Ajouter un invité'"
        @add="displayAddGuestPopup"
      />

      <div class="flex-shrink" />

      <!-- BEGIN Search engine and alphabetic order -->
      <div class="flex justify-end flex-grow">
        <div
          class="relative w-full sm:w-1/4 text-gray-400 focus-within:text-gray-600 border border-gray-200 mr-5"
        >
          <input
            id="search_field"
            v-model="searchGuest"
            class="block w-full px-4 py-3 2xl:px-5 2xl:py-4 shadow-md rounded-md text-gray-900 placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 text-sm"
            placeholder="Rechercher un invité"
            type="search"
          >
          <div
            v-show="!searchGuest"
            class="absolute mr-2 inset-y-0 right-0 flex items-center pointer-events-none text-indigo-600"
          >
            <icon
              name="search"
              class="h-3 w-3 mr-1 sm:h-4 sm:w-4 sm:mr-1.5"
            />
          </div>
        </div>

        <sort-button
          :sort="sort"
          @sorted="
            (sortType) => {
              sort = sortType;
            }
          "
        />
      </div>
      <!-- END Search engine and alphabetic order -->
    </div>
    <!-- END add new + search + sort -->

    <div
      v-if="guests.length > 0"
      class="text-lg text-gray-600 h-16 lg:h-24 2xl:h-32 grid grid-cols-12 gap-x-4 place-content-center"
    >
      <div class="col-start-2 col-span-3">
        Invités
      </div>
      <div class="col-span-3">
        Droits d'accès
      </div>
      <div class="col-span-3">
        Révoquer les droits
      </div>
      <div class="col-span-2">
        Statut
      </div>
    </div>

    <div
      v-if="guests.length > 0 && guestsSortByTrashed.length === 0"
      class="flex flex-col justify-center items-center w-full"
    >
      <h3
        class="text-pink-600 w-full text-center font-semibold text-lg mt-12"
      >
        Aucun résultat !
      </h3>
      <h4 class="text-indigo-600 w-4/6 text-center text-base mt-8 mb-16">
        Aucun invité ne correspond à votre recherche, veuillez réessayer
        avec de nouveaux éléments
      </h4>
      <div>
        <illustration name="no_result" />
      </div>
    </div>
    <div
      v-if="guests.length === 0"
      class="flex flex-col justify-center items-center w-full"
    >
      <h3
        class="text-pink-600 w-full text-center font-semibold text-lg mt-12"
      >
        Aucun invité
      </h3>
      <h4 class="text-indigo-600 w-4/6 text-center text-base mt-8 mb-16">
        Il n'y a aucun invité rattaché à votre compte
      </h4>
      <div>
        <illustration name="no_result" />
      </div>
    </div>

    <!-- BEGIN list of referents -->
    <div
      v-for="(guest, num_guest) in guestsSortByTrashed"
      :key="num_guest"
      class="even:bg-gray-200 even:bg-opacity-50"
    >
      <!-- BEGIN Informations on accordion -->
      <div
        class="h-16 lg:h-24 2xl:h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 place-content-center"
      >
        <div class="col-span-1 place-self-center">
          <ProfilePicture
            size="max-w-10 w-10 h-10"
            :other-object="guest"
          />
        </div>

        <div
          class="col-span-3 text-lg place-self-center justify-self-start"
          :class="{
            'text-gray-900': guest.is_active,
            'text-gray-600': !guest.is_active,
          }"
        >
          <!-- Invité -->
          {{ guest.firstname }}
          <span class="uppercase">{{ guest.lastname }}</span>
        </div>

        <div
          class="col-span-3 text-lg text-indigo-600 place-self-center justify-self-start"
        >
          <!-- Droits d'accès -->
          <action-button
            border-color="border-transparent"
            text-color="text-gray-900"
            bg-color="bg-teal-300"
            bg-color-square="bg-teal-100"
            icon-color="text-teal-600"
            libelle="Droits d'accès"
            :responsive="true"
            icon="layers"
            @clickAction="
              guest.is_active
                ? displaySpecificRightsPopup(guest)
                : null

            "
            :is-disabled="!guest.is_active"
          />
        </div>

        <div class="col-span-3 place-self-center justify-self-start">
          <!-- Révoquer les droits -->
          <action-button
            border-color="border-transparent"
            text-color="text-gray-900"
            bg-color="bg-pink-300"
            bg-color-square="bg-pink-100"
            icon-color="text-pink-600"
            libelle="Révoquer les droits"
            :responsive="true"
            icon="close"
            @clickAction="
              guest.is_active
                ? displayDeactivateGuestPopup(guest)
                : null

            "
            :is-disabled="!guest.is_active"
          />
        </div>
        <div
          class="col-span-2 place-self-center justify-self-start"
          :class="{
            'text-teal-600': guest.is_active,
            'text-pink-600': !guest.is_active,
          }"
        >
          {{ guest.is_active ? 'Actif' : 'Inactif' }}
        </div>
      </div>
      <!-- END Informations on accordion -->
    </div>
    <!-- END list of referents -->
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Icon from './../../components/Icon';
import ActionButton from './../../components/ActionButton';
import AddButton from '../../components/Inputs/AddButton.vue';
import SortButton from './../../components/SortButton';
import Illustration from '../../components/Illustration';
import ProfilePicture from '../../components/ProfilePicture.vue';

import Constants from '../../constants';

import AddGuest from './popup/AddGuest.vue';
import EditGuestSpecificRights from './popup/EditGuestSpecificRights.vue';
import DeleteGuest from './popup/DeleteGuest.vue';

export default {
  name: 'Guests',

  components: {
    ProfilePicture,
    Icon,
    ActionButton,
    SortButton,
    Illustration,
    AddButton,
    AddGuest,
    EditGuestSpecificRights,
    DeleteGuest,
  },

  data() {
    return {
      isAddGuestPopupOpened: false,
      isSpecificRightsPopupOpened: false,
      isDeactivateGuestPopupOpened: '',
      searchGuest: '',
      sort: 'DEC',
      sortDate: 'olderToYounger',
      constants: Constants,
    };
  },

  mounted() {
    this.loadModulesPages();
  },

  methods: {
    ...mapMutations({
      SET_LOADING: 'app/SET_LOADING',
      SET_GUESTTOEDIT: 'invites/SET_GUESTTOEDIT',
      SET_SPECIFICRIGHTSTOEDIT: 'invites/SET_SPECIFICRIGHTSTOEDIT',
    }),

    ...mapActions({
      loadSpecifiesPermissions: 'invites/loadSpecifiesPermissions',
      loadModulesPages: 'permissions/loadModulesPages',
    }),

    createPermissionsGrid() {
      let specificRights = {
        rights: {
          neopassForm: {
            read: {
              all: false,
            },
            edit: {
              all: false,
            },
          },
        },
      };
      this.listNeopassModulesPages.forEach((module) => {
        specificRights.rights.neopassForm.read[module.name] = { all: false };
        specificRights.rights.neopassForm.edit[module.name] = { all: false };

        module.pages.forEach((page) => {
          specificRights.rights.neopassForm.read[module.name][
            page.name
          ] = false;
          specificRights.rights.neopassForm.edit[module.name][
            page.name
          ] = false;
        });
        if (
          [
            Constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO,
            Constants.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES,
            Constants.MODULE_NEOPASS_FORM_COMPETENCES_SCOLAIRES,
          ].includes(module.name)
        ) {        specificRights.rights.neopassForm.read[module.name][
          'auto_eval'
        ] = false;
        specificRights.rights.neopassForm.edit[module.name][
          'auto_eval'
        ] = false;}
      });

      this.SET_SPECIFICRIGHTSTOEDIT(specificRights);
    },

    async displayAddGuestPopup() {
      await this.SET_LOADING(true);
      await this.createPermissionsGrid();
      this.isAddGuestPopupOpened = true;
      this.SET_LOADING(false);
    },

    async displaySpecificRightsPopup(guest) {
      await this.SET_GUESTTOEDIT(guest);

      await this.loadSpecifiesPermissions();

      this.changeSpecificRightsPopupState(true);
    },

    changeSpecificRightsPopupState(state) {
      this.isSpecificRightsPopupOpened = state;

      if (!state) {
        this.SET_GUESTTOEDIT({});
      }
    },

    displayDeactivateGuestPopup(guest) {
      this.SET_GUESTTOEDIT(guest);
      this.changeDeactivateGuestPopupState('confirmation');
    },

    changeDeactivateGuestPopupState(state) {
      this.isDeactivateGuestPopupOpened = state;

      if (state === '') {
        this.SET_GUESTTOEDIT({});
      }
    },
  },

  computed: {
    ...mapGetters({
      guests: 'invites/guests',
      guestToEdit: 'invites/guestToEdit',
      listNeopassModulesPages: 'permissions/listNeopassModulesPages',
      specificRightsToEdit: 'invites/specificRightsToEdit',
    }),

    //Recherche guests
    guestsFilter: {
      get: function () {
        let filteredList;

        filteredList = [...this.guests].filter(
          (guest) =>
            guest.firstname
              .toLocaleLowerCase()
              .includes(this.searchGuest.toLocaleLowerCase()) ||
                        guest.lastname
                          .toLocaleLowerCase()
                          .includes(this.searchGuest.toLocaleLowerCase())
        );
        return filteredList;
      },
    },

    //Tri guests
    guestsSort() {
      let sortedList = [];

      if (['ABC', 'ZYX'].includes(this.sort)) {
        sortedList = [...this.guestsFilter].sort(function (a, b) {
          let nameA = a.lastname.toUpperCase();
          let nameB = b.lastname.toUpperCase();
          return nameA.localeCompare(nameB);
        });
      }

      if (['JAN', 'DEC'].includes(this.sort)) {
        sortedList = [...this.guestsFilter].sort(function (a, b) {
          let dateA = a.created_at;
          let dateB = b.created_at;
          return dateA.localeCompare(dateB);
        });
      }

      if (['ABC', 'JAN'].includes(this.sort)) {
        return sortedList;
      }
      if (['ZYX', 'DEC'].includes(this.sort)) {
        return sortedList.reverse();
      }
    },

    guestsSortByTrashed() {
      let activeGuests = this.guestsSort.filter((g) => g.is_active);
      let trashedGuests = this.guestsSort.filter((g) => !g.is_active);

      return [...activeGuests, ...trashedGuests];
    },
  },
};
</script>
